import React from 'react';
import { Users, Target, Shield, Zap } from 'lucide-react';
import { aboutData } from '../mock';

const AboutUs = () => {
  const iconMap = {
  "Reliable AI Systems": Shield,
  "Compliance-First Approach": Target,
  "Fast Time-to-Production": Zap,
  "No Compromise on Fundamentals": Users
};

  return (
    <section id="about" className="dark-full-container" style={{ paddingTop: '160px', paddingBottom: '80px' }}>
      <div className="dark-content-container">
        {/* Section Header */}
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '100px' }}>
          <h2 className="display-large" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
            {aboutData.title}
          </h2>
          <p className="body-large" style={{ maxWidth: '800px', margin: '0 auto' }}>
            {aboutData.subtitle}
          </p>
        </div>

        {/* Enhanced Content Sections */}
        <div className="reveal" style={{ marginBottom: '80px', maxWidth: '1000px', margin: '0 auto 80px auto' }}>
          
          {/* Mission */}
          <div 
            className="ui-card"
            style={{
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-subtle)',
              padding: '60px',
              marginBottom: '40px'
            }}
          >
            <h3 className="heading-1" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
              {aboutData.mission.title}
            </h3>
            <p className="body-medium" style={{ lineHeight: 1.7, fontSize: '18px' }}>
              {aboutData.mission.description}
            </p>
          </div>

          {/* Story */}
          <div 
            className="ui-card"
            style={{
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-subtle)',
              padding: '60px',
              marginBottom: '40px'
            }}
          >
            <h3 className="heading-1" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
              {aboutData.story.title}
            </h3>
            <p className="body-medium" style={{ lineHeight: 1.7, fontSize: '18px' }}>
              {aboutData.story.description}
            </p>
          </div>

          {/* What We Built */}
          <div 
            className="ui-card"
            style={{
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-subtle)',
              padding: '60px',
              marginBottom: '40px'
            }}
          >
            <h3 className="heading-1" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
              {aboutData.whatWeBuild.title}
            </h3>
            <p className="body-medium" style={{ lineHeight: 1.7, fontSize: '18px' }}>
              {aboutData.whatWeBuild.description}
            </p>
          </div>

          {/* Two Column Layout for Impact and Difference */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '40px',
            marginBottom: '40px'
          }}>
            <div 
              className="ui-card"
            style={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border-subtle)',
                padding: '50px'
              }}
            >
              <h3 className="heading-1" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
                {aboutData.impact.title}
              </h3>
              <p className="body-medium" style={{ lineHeight: 1.7 }}>
                {aboutData.impact.description}
              </p>
            </div>

            <div 
              className="ui-card"
            style={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border-subtle)',
                padding: '50px'
              }}
            >
              <h3 className="heading-1" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
                {aboutData.difference.title}
              </h3>
              <p className="body-medium" style={{ lineHeight: 1.7 }}>
                {aboutData.difference.description}
              </p>
            </div>
          </div>

          {/* Vision */}
          <div style={{
            background: 'var(--bg-primary)',
            border: '2px solid var(--brand-primary)',
            padding: '60px',
            textAlign: 'center',
            marginBottom: '40px'
          }}>
            <h3 className="heading-1" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
              {aboutData.vision.title}
            </h3>
            <p className="body-large" style={{ lineHeight: 1.7, fontSize: '20px', marginBottom: '32px' }}>
              {aboutData.vision.description}
            </p>
            <div style={{
              fontSize: '22px',
              fontWeight: 600,
              color: 'var(--brand-primary)',
              fontStyle: 'italic'
            }}>
              {aboutData.tagline}
            </div>
          </div>

        </div>

        {/* Values */}
        <div style={{ marginBottom: '0px' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h3 className="display-medium" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
              Our Values
            </h3>
            <p className="body-large" style={{ maxWidth: '600px', margin: '0 auto' }}>
              The principles that guide everything we build
            </p>
          </div>
          
          <div className="dark-grid">
            {aboutData.values.map((value, index) => {
              const IconComponent = iconMap[value.title];
              return (
                <div 
                  key={index}
                  className="diff-card reveal"
                  style={{ transitionDelay: `${index * 0.1}s` }}
                >
                  <IconComponent 
                    size={48} 
                    color="var(--brand-primary)" 
                    className="icon-badge"
                    style={{ marginBottom: '24px' }}
                  />
                  <h4 className="heading-2" style={{ marginBottom: '16px' }}>
                    {value.title}
                  </h4>
                  <p className="body-medium">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Leadership Team */}
        <div className="reveal" style={{ marginTop: '160px' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h3 className="display-medium" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
              {aboutData.team.title}
            </h3>
            <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
              {aboutData.team.subtitle}
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '32px',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            {aboutData.team.members.map((member, index) => (
              <div
                key={index}
                style={{
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-subtle)',
                  borderRadius: '6px',
                  padding: '32px',
                  textAlign: 'center'
                }}
              >
                <h4 className="heading-3" style={{ marginBottom: '4px' }}>
                  {member.name}
                </h4>
                <p style={{
                  color: 'var(--brand-primary)',
                  fontSize: '15px',
                  fontWeight: 500,
                  marginBottom: '12px'
                }}>
                  {member.role}
                </p>
                <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '4px' }}>
                  {member.credentials}
                </p>
                <p className="body-small" style={{ color: 'var(--text-muted)' }}>
                  {member.background}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;